<template>
  <b-row>
    <b-col
      v-for="(assembleia, index) in assembleias"
      :key="index"
      class="mt-0 d-flex"
      cols="12"
      xl="4"
      lg="4"
      md="4"
    >
      <assembleia-card
        :assembleia="assembleia"
        @assembleiaClick="$emit('assembleiaClick', assembleia.id)"
      />
    </b-col>
    <b-col
      cols="12"
    >
      <no-content-assembleia v-if="!assembleias || assembleias.length == 0" />
    </b-col>
  </b-row>
</template>

<script>
import NoContentAssembleia from './NoContentAssembleia.vue'
import AssembleiaCard from './AssembleiaCard.vue'

export default {
  components: {
    AssembleiaCard,
    NoContentAssembleia,
  },
  props: {
    assembleias: {
      type: Array,
      required: true,
    },
  },
}
</script>
